// mission-base-branch.ts — V2-1 review M3 (spec §4.1 luật auto điều 3, E12).
//
// `repo.base_branch` the PERSON declared in the init request (required by the
// init schema), persisted in the control root like the other init provenance
// files (mission-deploy-target.ts shape) — before V2 init validated it and
// dropped it. Read as the `base_ref` boundary token of the auto-decision rule
// (decision-auto-boundary-tokens.ts). A v1 mission has no file ⇒ `undefined`
// ⇒ the token falls back to `release.target_branch` only.
import { readFile } from "node:fs/promises";
import { join } from "node:path";
import { writeFileDurable } from "./durable-file-writer.js";

const BASE_BRANCH_FILE_NAME = "mission-base-branch.json";

export async function writeMissionBaseBranch(
  controlRoot: string,
  baseBranch: string,
  now: () => Date,
): Promise<void> {
  const payload = { schema_version: 1, base_branch: baseBranch, declared_at: now().toISOString() };
  await writeFileDurable(
    join(controlRoot, BASE_BRANCH_FILE_NAME),
    Buffer.from(`${JSON.stringify(payload, null, 2)}\n`, "utf8"),
  );
}

/** `undefined` = mission initialised before V2-1, or unreadable/hand-edited file. */
export async function readMissionBaseBranch(controlRoot: string): Promise<string | undefined> {
  try {
    const raw = await readFile(join(controlRoot, BASE_BRANCH_FILE_NAME), "utf8");
    const value = (JSON.parse(raw) as { base_branch?: unknown }).base_branch;
    return typeof value === "string" && value.trim().length > 0 ? value : undefined;
  } catch {
    return undefined;
  }
}
